import { ThunkConfig } from '@/types/store';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getError } from '@/utils/error-report/getError';
import { axiosInstanceNewAPI } from '@/services/api/utils/axiosInstance';
import { apiPath } from '@/redux/apiPath';
import { validateDataUsingZodSchema } from '@/utils/validateDataUsingZodSchema';
import { autocompleteSchema } from '@/models/autocompleteSchema';
import type { RootState } from '../store';

export const getSearchAutocomplete = createAsyncThunk<
  string[] | undefined,
  void,
  { state: RootState } & ThunkConfig
>('project/getSearchAutocomplete', async () => {
  try {
    const response = await axiosInstanceNewAPI.get<string[]>(apiPath.getSearchAutocomplete());

    const isDataValid = validateDataUsingZodSchema(response.data, autocompleteSchema);

    return isDataValid ? response.data : undefined;
  } catch (error) {
    return Promise.reject(getError({ error }));
  }
});

export const getDrugAutocomplete = createAsyncThunk<
  string[] | undefined,
  void,
  { state: RootState } & ThunkConfig
>('project/getDrugAutocomplete', async () => {
  try {
    const response = await axiosInstanceNewAPI.get<string[]>(apiPath.getDrugAutocomplete());

    const isDataValid = validateDataUsingZodSchema(response.data, autocompleteSchema);

    return isDataValid ? response.data : undefined;
  } catch (error) {
    return Promise.reject(getError({ error }));
  }
});

export const getChemicalAutocomplete = createAsyncThunk<
  string[] | undefined,
  void,
  { state: RootState } & ThunkConfig
>('project/getChemicalAutocomplete', async () => {
  try {
    const response = await axiosInstanceNewAPI.get<string[]>(apiPath.getChemicalAutocomplete());

    const isDataValid = validateDataUsingZodSchema(response.data, autocompleteSchema);

    return isDataValid ? response.data : undefined;
  } catch (error) {
    return Promise.reject(getError({ error }));
  }
});
